var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',{ref:"wrap",attrs:{"title":_vm.title}},[_c('iframe',{attrs:{"src":"http://bmwbmw2.6665432.com/fixtures/","scrolling":"no","frameBorder":"0","width":"900","height":"496"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c972efc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/QC38.vue
// module id = null
// module chunks = 